/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolTapasIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-tapas"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M7 23Q7 23 6.74 23Q6.47 23 6.11 22.64Q5.75 22.27 5.75 21.75L5.75 15.35L4 15.35Q2.83 15.35 2 14.53Q1.18 13.7 1.18 12.53Q1.18 11.35 2 10.53Q2.83 9.7 4 9.7L5.75 9.7L5.75 8.55L4 8.55Q2.83 8.55 2 7.72Q1.18 6.9 1.18 5.72Q1.18 4.55 2 3.73Q2.83 2.9 4 2.9L5.75 2.9L5.75 2.25Q5.75 1.73 6.11 1.36Q6.47 1 7 1Q7.53 1 7.89 1.36Q8.25 1.73 8.25 2.25L8.25 2.9L10 2.9Q11.18 2.9 12 3.73Q12.82 4.55 12.82 5.72Q12.82 6.9 12 7.72Q11.18 8.55 10 8.55L8.25 8.55L8.25 9.7L10 9.7Q11.18 9.7 12 10.53Q12.82 11.35 12.82 12.53Q12.82 13.7 12 14.53Q11.18 15.35 10 15.35L8.25 15.35L8.25 21.75Q8.25 22.27 7.89 22.64Q7.53 23 7 23ZM16.75 20.5L16.75 14.05Q15.4 13.65 14.57 12.54Q13.75 11.43 13.75 10L13.75 2.33Q13.75 1.77 14.14 1.39Q14.53 1 15.07 1L20.93 1Q21.48 1 21.86 1.39Q22.25 1.77 22.25 2.33L22.25 10Q22.25 11.43 21.43 12.54Q20.6 13.65 19.25 14.05L19.25 20.5L20 20.5Q20.52 20.5 20.89 20.86Q21.25 21.23 21.25 21.75Q21.25 22.27 20.89 22.64Q20.52 23 20 23L16 23Q15.47 23 15.11 22.64Q14.75 22.27 14.75 21.75Q14.75 21.23 15.11 20.86Q15.47 20.5 16 20.5ZM16.25 6L19.75 6L19.75 3.5L16.25 3.5Z" fill={color} />
    </svg>
  );
}
